import React, { useState, useEffect, useRef } from "react";
import EventHeader from "./components/EventHeader";
import BasicReport from "./components/ScoreREports/BasicReport";
import Footer from "./components/Footer/Footer";
import { CONFIG_VARS } from "./constants/configaration";
import loaderGif from "../accerts/gifs/LoaderGif.gif";
import { useParams } from "react-router-dom";

const BasicReportPage = () => {
  const { crnId, eventId } = useParams();
  const [loader, setLoader] = useState(true);
  const [reportData, setReportData] = useState(null);
  const [basicData, setBasicData] = useState(null);
  const [progressordata, setProgressordata] = useState(null);
  const [error, setError] = useState(null);
  const hasCalledRef = useRef(false);

  useEffect(() => {
    console.log("Component mounted or params changed", { crnId, eventId });
    fetchReports(crnId, eventId);
  }, [crnId, eventId]);
  const getCurrentExamFromURL = () => {
    const url = window.location.pathname.toLowerCase();

    if (url.includes("/score-report/")) return "score";
    if (url.includes("/math-report/")) return "math olympiad";
    if (url.includes("/hots-report/")) return "hots olympiad";
    if (url.includes("/yec-report/")) return "youth entrepreneurship challenge";

    return "unknown";
  };

  const currentExam = getCurrentExamFromURL();
  const fetchReports = async (crnId, eventId) => {
    console.log("Fetching reports...");
    setLoader(true);
    try {
      const cacheBuster = new Date().getTime();
      const url = `${CONFIG_VARS.S3buket}/${crnId}_${eventId}.json?cb=${cacheBuster}`;
      const res = await fetch(url, { mode: "cors" });

      if (res?.status === 200) {
        const data = await res?.json();
        setBasicData(data?.basic_report);
        setReportData(data);
        setProgressordata(data?.basic_report?.section_wise_marks);
      } else {
        setError("Reports are not available yet...");
      }
    } finally {
      setLoader(false);
    }
  };

  const handleRetry = () => {
    console.log("Retrying...");
    hasCalledRef.current = false;
    fetchReports(crnId, eventId);
  };

  return (
    <div className="Rep_main_cont">
      <EventHeader reportData={reportData} />
      {loader ? (
        <div className="Loader">
          <img src={loaderGif} alt="loading" />
          <h4>Wait we are preparing your reports....</h4>
        </div>
      ) : error || !basicData ? (
        <div className="Loader">
          <p>Basic Report is not available</p>
          <button onClick={handleRetry}>Retry</button>
        </div>
      ) : (
        <div className="LoaderbasicreportpageCont">
          <BasicReport
            reportData={reportData}
            progressordata={progressordata}
            currentExam={currentExam}
          />
        </div>
      )}

      <Footer />
    </div>
  );
};

export default BasicReportPage;
